'use strict';
/*****************************/
// Pace
/*****************************/
window.paceOptions = {
    eventLag: false,
    initialRate: 0.7,
    minTime: 1750,
    maxProgressPerFrame: 1,
    ghostTime: 120000

    //initialRate: 0.7,
    //minTime: 1750,
    //maxProgressPerFrame: 1,
    //ghostTime: 120000

    /*eventLag: false, // disabled*/
    //eventLag: {
    //    lagThreshold: 30
    //}
    //catchupTime: 1000,
    //ghostTime:12000,
    //minTime: 12000,
    //elements: {
    //    checkInterval: 100
    //}
};

import Pace from 'pace-js'
import Headroom from 'headroom.js';

//Pace.options = window.paceOptions;


/*****************************/
// Main
/*****************************/

let doOnce = true;
let offset;

function getTimeOffset(serverTime) {
    const clientTime = new Date();
    const timeOffset = serverTime.getTime() - clientTime.getTime();
    return timeOffset;
}

/**         
 * Compliment someone on their something.
 *
 * @param {Object} o                        Object
 * @param {String} o.sertTime               Server time (market time) in UTC must be in the follow format (yyyy-MM-dd HH:mm:ss), don't include timezone information
 * @param {String} o.serverTimezoneName     Timezone name
 * @param {String} o.holidayDates           Holidays comma separated
 * @param {String} o.closeEarlyDates        Close early comma separated
 * @param {String} o.elmId                  Element Id
 * @param {String} o.elmMarketStatusId      Market Element Id
 * @param {String} o.elmMarketStatusTextId  Market Text Element Id         
 * @param {String} o.marketCloseTime        Market Close time
 * @param {String} o.marketCloseEarlyTime   Market Close Early time
 * @param {String} o.marketOpenTime         Market Open time
 * @param {String} o.timeUpdateIntervalSec  Time interval in seconds
 */
function displayClock(o) {
    o = o || {};
    o.serverTime = o.serverTime || ''; //'2023-02-08 15:59:55'
    o.serverTimezoneName = o.serverTimezoneName || '';
    o.holidayDates = o.holidayDates || '';
    o.closeEarlyDates = o.closeEarlyDates || '';
    o.marketCloseEarlyTime = o.marketCloseEarlyTime || '';
    o.elmId = o.elmId || '';
    o.elmMarketStatusId = o.elmMarketStatusId || '';
    o.elmMarketStatusTextId = o.elmMarketStatusTextId || '';
    o.timeUpdateIntervalSec = o.timeUpdateIntervalSec || 60;
    o.marketCloseTime = o.marketCloseTime || '';
    o.marketOpenTime = o.marketOpenTime || '';
    
    // Constants            
    const timeUpdateMs = 1000 * o.timeUpdateIntervalSec;
    const localTime = new Date();

    // Convert the ISO 8601 standard to a date format that can be handled by IOS and IE
    var arr = o.serverTime.split(/[- :]/);
    var serverTime = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    //var serverTime = new Date(o.serverTime);

    // Get the offset once only
    offset = offset === undefined ? getTimeOffset(serverTime) : offset;   // Get the difference between client and server (only once);  //const diffMin = (serverTime - localTime) / (1000 * timeIntervalMins);              
    localTime.setTime(localTime.getTime() + offset);                      // Update client time to match server time            
    const nextTimeUpdateMs = timeUpdateMs - localTime % timeUpdateMs;     // Make sure clock updates once per minute (at 0 seconds);                                    

    var clockText = '';
    var marketIcon = '';
    var marketIconWeight = '';
    var marketStatusText = '';
    var marketStatusCss = 'market-indicator-open';
    const timezoneName = o.serverTimezoneName;
    const elmTimeId = o.elmId;
    const elmStatusId = o.elmMarketStatusId;
    const elmStatusTextId = o.elmMarketStatusTextId;
    const holidayDates = o.holidayDates;
    const closeEarlyDates = o.closeEarlyDates;
    const serverDateOnly = o.serverTime.split(' ')[0];

    const marketOpenTime = o.marketOpenTime;
    const marketCloseTime = o.marketCloseTime;
    const marketCloseEarlyTime = o.marketCloseEarlyTime;

    const monthArray = new Array('Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec');
    var currHours = localTime.getHours();
    var currMinutes = localTime.getMinutes();
    //const currSeconds = localTime.getSeconds();
    var currDays = localTime.getDate();
    const currMonths = localTime.getMonth();
    const currYears = localTime.getFullYear();
    const currDay = localTime.getDay();

    const isWeekend = currDay === 6 || currDay === 0;
    var isHolidayDate = holidayDates.indexOf(serverDateOnly) !== -1;

    // Market trading date time (including closed early)
    var marketOpeningDateTime = new Date(new Date(serverTime).setHours(marketOpenTime.split(':')[0], marketOpenTime.split(':')[1], 0, 0));
    var marketClosingDateTime = new Date(new Date(serverTime).setHours(marketCloseTime.split(':')[0], marketOpenTime.split(':')[1], 0, 0));
    var marketClosingEarlyDateTime = new Date(new Date(serverTime).setHours(marketCloseEarlyTime.split(':')[0], marketCloseEarlyTime.split(':')[1], 0, 0));

    // Check if outside market trading hours
    var isOutsideMarketTradingHours = localTime < marketOpeningDateTime || localTime > marketClosingDateTime;

    // Check if market is closing early
    var isClosingEarlyDateTime = closeEarlyDates.indexOf(serverDateOnly) !== -1 && localTime > marketClosingEarlyDateTime;

    // Default status
    marketIcon = 'fa-circle';
    marketIconWeight = 'fas';
    marketStatusText = 'Market Open';
    marketStatusCss = 'market-indicator-open';

    // Determine market status
    if (isHolidayDate || isWeekend || isOutsideMarketTradingHours || isClosingEarlyDateTime) {
        marketIcon = 'fa-circle';
        marketIconWeight = 'fas';
        marketStatusText = 'Market Closed';
        marketStatusCss = 'market-indicator-closed';
    }

    // Insert leading zero                                
    var ap = 'AM';
    if (currHours > 11) { ap = 'PM'; }
    if (currHours > 12) { currHours = currHours - 12; }
    if (currHours === 0) { currHours = 12; }
    if (currHours < 10 && ap === 'am') { currHours = '0' + currHours; }
    if (currMinutes < 10) { currMinutes = '0' + currMinutes; }
    if (currDays < 10) { currDays = '0' + currDays; }

    clockText = `<strong> ${currHours}:${currMinutes} ${ap}</strong>, ${currDays} ${monthArray[currMonths]} ${currYears} ${timezoneName}`;

    var elmTimeAll = document.querySelectorAll(elmTimeId);
    elmTimeAll.forEach((elmTime) => {
        if (elmTime !== null) {
            elmTime.innerHTML = clockText;
        }
    });
    
    // Only update the element if something has changed
    var changeMarketStatus = false;
    var elmStatusAll = document.querySelectorAll(elmStatusId);

    elmStatusAll.forEach((elmStatus) => {
        // Check elmStatus appears
        if (elmStatus !== null) {
            if (!elmStatus.classList.contains(marketStatusCss)) {
                changeMarketStatus = true;
            }
        }
    });
       

    // Only update the market status when something has changed
    if (changeMarketStatus || doOnce) {

        elmStatusAll.forEach((elmStatus) => {
            if (elmStatus !== null) {
                elmStatus.classList.remove('market-indicator-open');
                elmStatus.classList.remove('market-indicator-closed');
                elmStatus.classList.add(marketStatusCss);

                elmStatus.querySelector(elmStatusTextId).innerHTML = marketStatusText;
                elmStatus.title = `View Market Hours (${marketStatusText})`;
                
                var marketIconChange = document.querySelector('.market-indicator__icon use');
                marketIconChange.setAttribute('href', `#${marketIconWeight}-${marketIcon}`);
                //marketIconChange.classList.remove('far', 'fas', 'fa-circle');
                //marketIconChange.classList.add(marketIconWeight);
                //marketIconChange.classList.add(marketIcon);
            }
        });
               
        doOnce = false;

        // If the market is open dispatch event           
        var event = new CustomEvent('marketStatusChange', {
            detail: {
                status: marketStatusCss.indexOf('-open') !== -1 ? 'open' : 'closed'
            }
        });

        elmTimeAll.forEach((elmTime) => {
            if (elmTime !== null) {
                elmTime.dispatchEvent(event);
            }
        });
    }

    // Call displayClock again
    setTimeout(function () { displayClock(o); }, nextTimeUpdateMs);
}

function executeReCaptcha(siteKey, formId, action) {
    // hard code all actions as submit for now
    action = 'submit';

    window.grecaptcha.ready(function () {
        window.grecaptcha.execute(siteKey, { action: action })
            .then(function (token) {
                // Set `token` in a hidden form input.
                document.getElementById('captcha').value = token;
                //$('#captcha').val("token");

                //And finally submit the form by firing off the HTTP POST over the wire at this exact moment in time here.
                document.getElementById(formId).submit();
                //$(formId).submit();
            });
    });
}

function startPaceManually() {
    //window.Pace.options.maxProgressPerFrame = 1;
    Pace.options.catchupTime = 1000;
    Pace.options.ghostTime = 12000;
    Pace.options.minTime = 12000;
    Pace.options.elements.checkInterval = 100;
    Pace.restart();
}

function stopPaceManually() {
    setTimeout(function () { Pace.stop(); }, 300);
}

function submitFormWithRecaptcha(formId, recaptchaSiteKey) {

    const formElement = document.getElementById(formId);
    formElement.addEventListener('submit', function (e) {        
        e.preventDefault();        
        startPaceManually();
        executeReCaptcha(recaptchaSiteKey, formId, formId.replace('form-', ''));
    }, false);
   
    formElement.addEventListener('validation', function (e) {
        const isValid = e.detail.valid;

        if (isValid) {
            formElement.querySelector('[type="submit"]').disabled = true;
        }
        else {
            stopPaceManually();
        }
    });
}

window.framework = window.framework || {}
window.framework.Site = {
    displayClock,
    startPaceManually,
    stopPaceManually,
    submitFormWithRecaptcha
}

//document.addEventListener('touchstart', function(e) {}, { passive: true });

document.addEventListener('DOMContentLoaded', () => {
    // resize window
    function resizeWindow() {
        var timesRun = 0;
        var interval = setInterval(function () {
            timesRun += 1;
            if (timesRun === 5) {
                clearInterval(interval);
            }
            window.dispatchEvent(new Event('resize'));
        }, 62.5);
    }

    //  navbar toggle
    document.querySelectorAll('.navbar-toggler').forEach(item => {
        item.addEventListener('click', function (e) {
            if (this.classList.contains('left-sidebar-toggler')) {
                document.querySelector('body').classList.toggle('left-sidebar-hidden');
                resizeWindow();
            }

            if (this.classList.contains('right-sidebar-toggler')) {
                document.querySelector('body').classList.toggle('right-sidebar-hidden');
                resizeWindow();
            }

            if (this.classList.contains('mobile-leftside-toggler')) {
                document.querySelector('body').classList.toggle('mobile-leftside-show');
                resizeWindow();
            }

            if (this.classList.contains('mobile-rightside-toggler')) {
                document.querySelector('body').classList.toggle('mobile-rightside-show');
                resizeWindow();
            }
        });
    });

    // Side navbar
    const showNavbar = (toggleId, navId, bodyId, headerId) => {
        const toggle = document.getElementById(toggleId),
            nav = document.getElementById(navId),
            bodypd = document.getElementById(bodyId),
            headerpd = document.getElementById(headerId),
            close = document.querySelector('.sidebar-nav__close');

        // Validate that all variables exist
        if (toggle && nav && bodypd && headerpd) {
            toggle.addEventListener('click', () => {
                nav.classList.toggle('sidebar-nav__wrapper-show'); // show navbar
                nav.classList.add('sidebar-nav__wrapper-mobile');
                toggle.classList.toggle('bx-x'); // change icon
                bodypd.classList.toggle('body-pd'); // add padding to body
                headerpd.classList.toggle('body-pd');                // add padding to header
            });

            nav.addEventListener('mouseenter', () => {
                nav.classList.add('sidebar-nav__wrapper-show');
                toggle.classList.add('bx-x');
                bodypd.classList.add('body-pd');
                headerpd.classList.add('body-pd');
            });

            nav.addEventListener('mouseleave', () => {
                if (!nav.classList.contains('sidebar-nav__wrapper-mobile')) {
                    nav.classList.remove('sidebar-nav__wrapper-show');
                    toggle.classList.remove('bx-x');
                    bodypd.classList.remove('body-pd');
                    headerpd.classList.remove('body-pd');
                }
            });

            close.addEventListener('click', (e) => {
                e.preventDefault();
                nav.classList.remove('sidebar-nav__wrapper-show');
                nav.classList.remove('sidebar-nav__wrapper-mobile');
                toggle.classList.remove('bx-x');
                bodypd.classList.remove('body-pd');
                headerpd.classList.remove('body-pd');
            });
        }
    }

    showNavbar('header-toggle', 'sidebar-nav-wrapper', 'body-pd', 'header');

    /*===== LINK ACTIVE =====*/
    //const linkColor = document.querySelectorAll('.nav_link');

    //function colorLink() {
    //    if (linkColor) {
    //        linkColor.forEach(l => l.classList.remove('active'));
    //        this.classList.add('active');
    //    }
    //}
    //linkColor.forEach(l => l.addEventListener('click', colorLink));



//// TODO: Need to fix modals to not use jQuery
////(function ($) {
////    function ModalBootstrap() {
////        var $this = this;

////        function initilizeModel() {
////            $('.modal-bootstrap').on('loaded.bs.modal', function () {
////            }).on('hidden.bs.modal', function () {
////                $(this).removeData('bs.modal');
////                });

////            // boostrap 4 load modal example from docs
////            $('.modal-bootstrap').on('show.bs.modal', function (event) {
////                //var button = $(event.relatedTarget); // Button that triggered the modal
////                //var url = button.attr("href");
////                //var modal = $(this);

////                //// note that this will replace the content of modal-content every time the modal is opened
////                //modal.find('.modal-content').load(url);
////                $(this).find('.modal-content').load(event.relatedTarget.href);
////            });
////        }

////        $this.init = function () {
////            initilizeModel();
////        };
////    }

////    $(function () {
////        var self = new ModalBootstrap();
////        self.init();
////    });

    //function ModalBootstrap() {
    //    var self = this;

    //    function initializeModal() {
    //        var modals = document.querySelectorAll('.modal-bootstrap');
    //        modals.forEach(function (modal) {
    //            modal.addEventListener('loaded.bs.modal', function () { });
    //            modal.addEventListener('hidden.bs.modal', function () {
    //                modal.removeAttribute('data-bs-backdrop');
    //                modal.removeAttribute('data-bs-keyboard');
    //            });

    //            modal.addEventListener('show.bs.modal', function (event) {
    //                var modalContent = modal.querySelector('.modal-content');
    //                modalContent.innerHTML = '';

    //                fetch(event.relatedTarget.href, {
    //                    headers: {
    //                        'X-Requested-With': 'XMLHttpRequest'
    //                    }
    //                }).then(function (response) {
    //                    return response.text();
    //                }).then(function (html) {
    //                    modalContent.innerHTML = html;

    //                    if (window.htmx) {
    //                        htmx.process(modal);
    //                    }

    //                    if (v) {
    //                        v.bootstrap();
    //                    }
    //                });
    //            });
    //        });
    //    }

    //    self.init = function () {
    //        initializeModal();
    //    };
    //}

    //var modalBootstrap = new ModalBootstrap();
    //modalBootstrap.init();

    //


    //// Double tap issue
    //$('a.nav-link,a.tab-link').on('click touchend', function (e) {
    //    var el = $(this);
    //    var link = el.attr('href');

    //    if (link !== '#' && link !== undefined) {
    //        window.location = link;
    //    }
    //});

    // sticky hover fix in iOS
    // ReSharper disable once MissingHasOwnPropertyInForeach
/*    (function (l) { var i, s = { touchend: function () { } }; for (i in s) l.addEventListener(i, s) })(document);*/ // sticky hover fix in iOS //(function (l) { var i, s = { touchend: function () { } }; for (i in s) if (s.hasOwnProperty(i)) l.addEventListener(i, s); })(document);

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

    const isStandAloneMode = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

    // Only apply install prompt, if not standalone mode
    if (!isStandAloneMode) {
        let deferredPrompt;
        var btnAdd = document.querySelector('.add-to-home-screen');

        if (btnAdd !== null && btnAdd !== undefined) {
            // ReSharper disable once Html.EventNotResolved
            window.addEventListener('beforeinstallprompt', function (e) {
                // Prevent Chrome 67 and earlier from automatically showing the prompt
                e.preventDefault();
                // Stash the event so it can be triggered later.
                deferredPrompt = e;
                // Update UI notify the user they can add to home screen
                btnAdd.style.display = 'inline';
            });

            // Installation must be done by a user gesture! Here, the button click
            btnAdd.addEventListener('click', (e) => {
                e.preventDefault();
                // hide our user interface that shows our A2HS button
                btnAdd.style.display = 'none';
                // Show the prompt
                deferredPrompt.prompt();
                // Wait for the user to respond to the prompt
                deferredPrompt.userChoice
                    .then((choiceResult) => {
                        if (choiceResult.outcome === 'accepted') {
                            // hide our user interface that shows our A2HS button
                            btnAdd.style.display = 'none';
                            //console.log('User accepted the A2HS prompt');
                        }
                        //else {
                            //console.log('User dismissed the A2HS prompt');
                        //}
                        deferredPrompt = null;
                    });
            });
        }
    }   
    
    // https://codepen.io/desirecode/pen/MJPJqV (for floating version)
    var backToTopElement = document.getElementById('btn-back-top');
    if (backToTopElement) {
        backToTopElement.addEventListener('click', function (e) {
            e.preventDefault();
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        });
    }
});

/*****************************/
// Headroom
/*****************************/
var header = document.querySelector('header');
if (header !== null) {
    const headroom = new Headroom(header, {
        offset: 205,
        tolerance: {
            down: 0,
            up: 0
        },
        classes: {
            initial: 'animated',
            pinned: 'slideDown',
            unpinned: 'slideUp'
        }
    });
    headroom.init();
}

window.addEventListener('beforeunload', () => {
    if (Pace) {              
        Pace.options.ghostTime = 12000;
        Pace.restart();
        //window.Pace.options.minTime = 12000;
        //window.Pace.options.elements.checkInterval = 100;
    }

    //framework.Site.startPaceManually();

    //window.Pace.options = { ghostTime: 12000 };
    //window.Pace.restart();

    /*startPaceManually();*/
    //window.Pace.options.catchupTime = 1000;
    //console.log('move away');
});


/*****************************/
// Service worker
/*****************************/
if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .register('/serviceworker.js');
        //.then(function () { console.log('Service Worker Registered'); });
}